<template>
        <div class="info-component-wrapper">
        <template v-if="openlearnAboutPanel">
            <learn-about @close="openlearnAboutPanel = false"></learn-about>
        </template>
            <div class="d-flex" style="border-bottom: 1px solid #242424;position:relative;padding:16px;">
                <h6 class="m-0 text-left pl-4" style="width: 84%;">{{$t('License Info')}}</h6>
                <button class="learn-about-text-styles" @click="openLearnAboutPanel()" title="Learn about license" style="padding-inline-end:16px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lightbulb-fill" viewBox="0 0 16 16">
                        <path d="M2 6a6 6 0 1 1 10.174 4.31c-.203.196-.359.4-.453.619l-.762 1.769A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.46-.302l-.761-1.77a1.964 1.964 0 0 0-.453-.618A5.984 5.984 0 0 1 2 6zm3 8.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1l-.224.447a1 1 0 0 1-.894.553H6.618a1 1 0 0 1-.894-.553L5.5 15a.5.5 0 0 1-.5-.5z"/>
                    </svg>{{$t('Learn about license')}}
                </button>
            </div>
            <div class="primary-btn-style justify-content-end pt-2 col-md-12" style="height:55px;">
                <button class="btn btn-outline-secondary m-2" style="border: 1px solid #585858;"
                    @click="downloadSysInfo()" title="Download System Info">{{$t('Download System Info')}}</button>
                <label class="btn btn-outline-primary m-2 mr-4" title="Upload License"
                    >{{$t('Upload License')}}
                    <input
                        style="height:100%;width:100%"
                        type="file"
                        id="file"
                        ref="uploadFile"
                        accept=".pkl"
                        v-on:click="resetImageUploader()"
                        v-on:change="uploadLicenseInfo()"
                        />
                </label>
            </div>
            <div style="height: calc(100% - 80px - 55px);overflow: auto;">
                <ul class="parent1-ul" v-if="licenseInfo.length > 0">
                    <li class="un-ordered-lists-style" style="font-size: 16px !important;">
                            <div class="key-style" style="margin-inline-end: 11px;width:16%">{{$t('licensed to')}} : </div>
                            <div class="value-style">{{licenseInfo[0].license_to}}</div>
                    </li>
                    <div v-for="eachLicense of filteredLicenseInfo" :key="eachLicense._id" class="acc-card" :class="{ open: openAccordions[eachLicense._id] }" start="1">
                        <!-- <template v-if='!getExternalPluginsLicenseNames.includes(eachLicense.license_name)'> -->
                            <div class="acc-head" role="button" tabindex="0" @click="toggleAccoridion(eachLicense._id, eachLicense.license_name)">
                                <div class="acc-left">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-key-fill" style="transform: rotate(45deg);margin-inline-end: 7px;margin-top:3px;" viewBox="0 0 16 16">
                                        <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                    </svg>
                                    <div>
                                        <div class="acc-title">{{ eachLicense.license_name }}</div>
                                    </div>
                                </div>

                                <div class="acc-right">
                                    <template v-if="eachLicense.updated_datetime" >
                                        <span class="learn-about-text-styles">
                                            {{$t('Last updated')}}: {{getDateAndTimeInConfiguredFormat(eachLicense.updated_datetime)}}
                                        </span>
                                    </template>
                                    <div class="acc-actions-inline actions-on-license">
                                        <label :for="'file-' + eachLicense._id" class="upload-label">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-upload" viewBox="0 0 16 16">
                                                <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                                                <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
                                            </svg>
                                        </label>

                                        <input
                                            :id="'file-' + eachLicense._id"
                                            type="file"
                                            accept=".pkl"
                                            style="display: none"
                                            @click.stop="$event.target.value = null"
                                            @change="uploadSubLicenseRequest(eachLicense._id, eachLicense.license_name, $event)"
                                        />
                                    </div>
                                    <div class="chev">
                                        <svg v-if="openAccordions[eachLicense._id]" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                                        </svg>
                                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <div v-if="openAccordions[eachLicense._id]" class="acc-body">
                                <template v-if="eachLicense.license_name == 'Core license' || eachLicense.license_name == 'Node license'"> 
                                    <div v-if="eachLicense.node_license_info" style="padding: 2px;display:inline-flex;width:100%;">
                                        <div
                                            :key="licenseKey"
                                            class="kv"
                                        >
                                        <div class="k">{{$t('Node')}}(<span style="text-transform: lowercase">s</span>):</div>
                                            <!-- <div class="v"> -->
                                                <div v-for="node in eachLicense.node_license_info" :key="node.hostname" class="value-style tag-style v" style="width:auto">
                                                    <span>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pc-display-horizontal mr-2" viewBox="0 0 16 16" style="position: relative;bottom: 1px;fill: #9f9f9f;">
                                                        <path d="M1.5 0A1.5 1.5 0 0 0 0 1.5v7A1.5 1.5 0 0 0 1.5 10H6v1H1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-5v-1h4.5A1.5 1.5 0 0 0 16 8.5v-7A1.5 1.5 0 0 0 14.5 0h-13Zm0 1h13a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5ZM12 12.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm2 0a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM1.5 12h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1ZM1 14.25a.25.25 0 0 1 .25-.25h5.5a.25.25 0 1 1 0 .5h-5.5a.25.25 0 0 1-.25-.25Z"/>
                                                        </svg>{{node.hostname}}
                                                    </span>
                                                </div>
                                            <!-- </div> -->
                                        </div>
                                    </div>
                            
                                    <div class="kv-grid">            
                                        <template v-for="licenseKey of Object.keys(eachLicense)">
                                            <template v-if="!['_id','expiry_date','updated_datetime','node_license_info','license_name','license_to'].includes(licenseKey)">
                                                <div
                                                    :key="licenseKey"
                                                    class="kv"
                                                >
                                                    <div class="k">{{ licenseKey.replace(/_/g, " ").charAt(0).toUpperCase() + licenseKey.replace(/_/g, " ").slice(1) }}</div>
                                                    <div class="v"
                                                        :class=" { 'text-danger':(licenseKey == 'status' && eachLicense[licenseKey] == 'Expired'),
                                                            'text-warning':(licenseKey == 'status' && eachLicense[licenseKey] == 'Invalid'),
                                                            'text-success':(licenseKey == 'status' && eachLicense[licenseKey] == 'Active')}">
                                                            {{licenseKey == 'created_datetime'?getDateAndTimeInConfiguredFormat(eachLicense.created_datetime):eachLicense[licenseKey]}}
                                                        <span v-if="(licenseKey == 'status' && eachLicense[licenseKey] == 'Active') && 'expiry_date' in eachLicense && eachLicense.expiry_date">
                                                            ( till {{eachLicense["expiry_date"]}} )
                                                        </span>
                                                        <span v-if="(licenseKey == 'status' && eachLicense[licenseKey] == 'Expired')">
                                                            ( on {{eachLicense["expiry_date"]}} )
                                                        </span>
                                                    </div>
                                                </div>
                                            </template>    
                                        </template>
                                        
                                    </div>
                                </template>  
                                <template v-if="eachLicense.license_name == 'Archive storage'">
                                    <div class="kv-grid" :key="eachLicense._id">
                                        <template v-for="licenseKey in Object.keys(archiveStorageData)">
                                            <template v-if="!['_id','expiry_date','updated_datetime','node_license_info','license_name','license_to', 'storage_limit-unit', 'archived_storage-unit', 'modified_datetime'].includes(licenseKey)">
                                                <div
                                                    :key="licenseKey"
                                                    class="kv"
                                                >
                                                    <div class="k">{{ licenseKey.replace(/_/g, " ").charAt(0).toUpperCase() + licenseKey.replace(/_/g, " ").slice(1) }}
                                                        <span v-if="licenseKey == 'storage_limit'">({{ archiveStorageData['storage_limit-unit'] }})</span>
                                                        <span v-if="licenseKey == 'archived_storage'">({{ archiveStorageData['archived_storage-unit'] }})</span>
                                                        <span v-if="(licenseKey == 'status' && archiveStorageData['status'] == 'expired')" style="color:#fb5b5b;margin-inline-start:5px;">({{$t('Exceeded')}})</span>
                                                    </div>
                                                    <div class="v"
                                                        :class=" {
                                                            'text-danger':(licenseKey == 'status' && archiveStorageData['status'] == 'expired')}">
                                                            {{licenseKey == 'created_datetime'?getDateAndTimeInConfiguredFormat(archiveStorageData.created_datetime):archiveStorageData[licenseKey]}}
                                                    </div>
                                                </div>
                                            </template>    
                                        </template>
                                    </div>    
                                </template>
                                
                                <template v-if="eachLicense.license_name == 'Adobe plugin'">
                                    <div class="kv-grid" :key="eachLicense._id">
                                        <template v-for="licenseKey in Object.keys(adobePluginData)">
                                            <template v-if="!['_id','expiry_date','updated_datetime','node_license_info','license_name','license_to', 'modified_datetime', 'licensed_users_info','licensed_users'].includes(licenseKey)">
                                                <div
                                                    :key="licenseKey"
                                                    class="kv"
                                                >
                                                    <div class="k">{{ licenseKey.replace(/_/g, " ").charAt(0).toUpperCase() + licenseKey.replace(/_/g, " ").slice(1) }}
                                                        <span v-if="(licenseKey == 'users_limit' && adobePluginData['users_limit'] < userTypes.length)" style="color:#fb5b5b;margin-inline-start:5px;">({{$t('Exceeded')}})</span>
                                                    </div>
                                                    <div class="v" v-if="licenseKey != 'licensed_users' && licenseKey != 'licensed_users_info'"
                                                        :class=" {'text-danger':(licenseKey == 'users_limit' && adobePluginData['users_limit'] < userTypes.length)}">
                                                            {{licenseKey == 'created_datetime'?getDateAndTimeInConfiguredFormat(adobePluginData.created_datetime):adobePluginData[licenseKey]}}
                                                    </div>
                                                </div>
                                            </template>    
                                        </template>
                                    </div>  
                                    <template v-for="licenseKey in Object.keys(adobePluginData)">
                                        <div class="k" :key="licenseKey" v-if="licenseKey == 'licensed_users'"  style="margin-top:8px;margin-bottom:4px;padding-inline-start: 14px;">{{ licenseKey.replace(/_/g, " ").charAt(0).toUpperCase() + licenseKey.replace(/_/g, " ").slice(1) }}
                                            <span v-if="(licenseKey == 'licensed_users' && adobePluginData['users_limit'] < userTypes.length)" style="color:#fb5b5b;margin-inline-start:5px;">({{$t('Exceeded')}})</span>
                                        </div>
                                        <div v-if="licenseKey == 'licensed_users'" :key="licenseKey" class="adobe-users-wrapper">
                                            <div v-if="!isEditable('licensed_users')" class="users-readonly-list-wrapper">
                                                <template v-if="adobePluginData.licensed_users.length >0">   
                                                    <div v-for="(user, index) in allUserInfo" :key="index" class="users-readonly-list">
                                                        <div v-if="user.profile_image" class='user-name-or-image'>
                                                            <img :src="getProxyConvertedURL(user.profile_image)" @error="replaceWithUserIcon($event)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                                        </div>
                                                        <div v-else class="user-name-or-image user-name" :style="style(user.username)">{{ user.username.split("")[0] }}
                                                        </div> 
                                                        <div style="display: flex;align-items: center;">{{user.username}}</div>
                                                    </div>
                                                </template>
                                                <div v-else style="margin-inline-start: 20px;color: #939090;">
                                                    {{ $t('No Users added yet') }}
                                                </div>    
                                            </div>
                                            <user-multiselect
                                                v-else 
                                                ref="userMultiselect" 
                                                :selectedUserIdList="userTypes" 
                                                :enableCheckbox="true" 
                                                :isSearchable="true" 
                                                @updatedUsersList='updatedUsersList' 
                                                @removedUserFromList='removedUserFromList'  
                                                :closeOnSelect="false"
                                                :class="!isEditable('licensed_users')?'disable-users-selection':''"
                                            >
                                            </user-multiselect>

                                            <edit-icon v-if="!isEditable('licensed_users')" @click.native="editLinkTypeFields('licensed_users')" class="editIcon"></edit-icon>
                                            <div v-if="isEditable('licensed_users')" class="d-flex" style="align-items: center;">
                                                <save-icon @click.native="updateAdobeUsersList('licensed_users')"></save-icon>
                                                <cancel-icon @click.native="cancelAdobeUSerListUpdate"></cancel-icon>
                                            </div>
                                        </div>
                                    </template>    
                                </template>
                            </div>
                        <!-- </template>     -->
                    </div>
                    <template v-for="list in getPluginLicensePlugins.filter(op=>!('position' in op))">
                        <component 
                        :ref="(el) => setComponentRef(el,list.componentRef)"  
                        v-if="evaluatePluginCondition(list)" 
                        :key="list.id" 
                        :is="list.component"
                        :allLicenseList = licenseInfo 
                        @uploadingSubLicense="uploadSubLicenseRequest"
                        ></component>
                    </template>
                </ul>
                <div v-else class="mt-4" style="height: 94%; overflow: auto;width: 94%; margin: 0px 3%">
                    <div class="note-div">
                        <div style="padding-inline-end: 5px; position: relative; top: 4px">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                viewBox="0 0 16 16"
                                class="bi bi-journal-text"
                                >
                                <path
                                d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"
                                ></path>
                                <path
                                d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"
                                ></path>
                                <path
                                d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"
                                ></path>
                            </svg>
                        </div>
                        <div>
                            <p style="color: #e8912d; font-size: 22px">
                                {{$t('Steps to add license')}}:
                            </p>
                            <div class="text-with-bullets-wrapper">
                                <div>
                                    <div class="bullets">1</div>
                                </div>
                                <div>{{$t('Download system info')}}</div>
                            </div><br>
                            <div class="text-with-bullets-wrapper">
                                <div>
                                    <div class="bullets">2</div>
                                </div>
                                <div>{{$t('Provide downloaded system-info file to support team')}}</div>
                            </div><br>
                            <div class="text-with-bullets-wrapper">
                                <div>
                                    <div class="bullets">3</div>
                                </div>
                                <div>{{$t('Get the license-info file from support team and upload it')}}</div>
                            </div><br>
                            <div class="text-with-bullets-wrapper">
                                <div >
                                    <div class="bullets">4</div>
                                </div>
                                <div >{{$t('Relogin to the FUSION')}}</div>
                            </div><br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
// import axios from "axios";
import Utils from "../../components.utils.js";
import Constants from "../../components.constants.js"
import LearnAbout from "../system/LearnAboutLicense.vue"
import userMultiselectDropdownField from "../users/UserMultiselectField.vue";
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import { mapMutations } from "vuex/dist/vuex.common.js";

export default{
    data(){
        return{
            openlearnAboutPanel:false,
            licenseInfo:[],
            openAccordions:{},
            archiveStorageData:{},
            adobePluginData:{},
            userTypes: [],
            editingKeyName:null,
            pluginsLicensePanelLoading : false,
        }
    },
    components:{
        "learn-about":LearnAbout,
        "user-multiselect":userMultiselectDropdownField,
        'cancel-icon':CancelIcon,
        "edit-icon":EditIcon,
        "save-icon":SaveIcon,
    },
    watch: {
        getPluginLicensePlugins: {
            immediate: true,
            deep: true,
            handler(newVal) {
                if (newVal && newVal.length) {
                this.loadPluginsDetailsPanel();
                }
            }
        },
    },
    methods:{
        style(name){
            let style = {
                'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
                'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
            }
            return style
        },
        setComponentRef(comp,name){
            if(name && comp && comp.$el){
                this.$refs[name] = comp.$el;
            }
        },   
        evaluatePluginCondition(list){
            return list.evalCondition(this);
        }, 
        async toggleAccoridion(typeId, licenseName) {
            if (licenseName === "Adobe plugin" && Object.keys(this.adobePluginData).length === 0) {
                const data = await this.getAdobePluginLicenseData();
                if (!data) return;

                this.adobePluginData = { ...data };
                delete this.adobePluginData.statusCode;
                this.userTypes =
                    (Object.keys(this.adobePluginData).length > 0 &&
                    Array.isArray(this.adobePluginData.licensed_users) &&
                    this.adobePluginData.licensed_users.length > 0)
                        ? [...this.adobePluginData.licensed_users]
                        : [];
            } else if (licenseName === "Archive storage" && Object.keys(this.archiveStorageData).length === 0) {
                const data = await this.getArchiveStorageLicenseData();
                if (!data) return;

                this.archiveStorageData = { ...data };
                delete this.archiveStorageData.statusCode;
            }

            this.$set(this.openAccordions, typeId, !this.openAccordions[typeId]);
        },
        async getAdobePluginLicenseData() {
            try {
                const data = await this.getAdobePluginLicenseDatafromServer();

                if (data && Utils.isAcceptedStatusCode(data.statusCode)) {
                    return data;
                } else {
                    if (data && (data.error || data.message)) {
                        this.$toast.error(data.error? data.error : data.message);
                    } else {
                        this.$toast.error(this.$t("Failed to fetch Adobe Plugin License details"));
                    }
                    return null;
                }
            } catch (error) {
                this.$toast.error(this.$t("Failed to fetch Adobe Plugin License details"));
                return null;
            }
        },
        
        async getArchiveStorageLicenseData() {
            try {
                const data = await this.getArchiveStorageLicenseDatafromServer();

                if (data && Utils.isAcceptedStatusCode(data.statusCode)) {
                    return data;
                } else {
                    if (data && (data.error || data.message)) {
                        this.$toast.error(data.error? data.error : data.message);
                    } else {
                        this.$toast.error(this.$t("Failed to fetch Archive Storage License details"));
                    }
                    return null;
                }
            } catch (error) {
                this.$toast.error(this.$t("Failed to fetch Archive Storage License details"));
                return null;
            }
        },

        openLearnAboutPanel(){
            this.openlearnAboutPanel = true;
            if (this.$refs.fadeWhenModelOpen) {
                this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
                this.$refs.fadeWhenModelOpen.style.pointerEvents = "none";
            }    
        },
        downloadSysInfo(){
            fetch(Constants.extendedUrl + '/download-system-info')
            .then(resp => resp.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = 'system_info.pkl';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                this.$toast.success(this.$t("Download submitted successfully"));
            })
            .catch(console.error);
        },
        formatDateAndTime(date){
            return Utils.getDateTimeFormat(date);
        },
        resetImageUploader(){
            this.$refs.uploadFile.value = '';
        },
        uploadLicenseInfo(){
            let selectedFileInfo = this.$refs.uploadFile.files[0];
            let formData = new FormData();
            formData.append("files", selectedFileInfo);
            this.getPathOfUploadedFile(formData).then((response) => {
                if (Utils.isAcceptedStatusCode(response.statusCode)) {
                if (
                    Object.keys(response).includes("message") &&
                    response.message.includes("Failed")
                ) {
                    this.$toast.warning(response.message);
                } else {
                    if (Object.keys(response).includes("message")) {
                    this.$toast.success(response.message);
                    } else {
                    this.$toast.success(this.$t("Uploaded successfully"));
                    }
                }
                } else {
                if (Object.keys(response).includes("message")) {
                    this.$toast.error(response.message);
                } else {
                    this.$toast.error(this.$t("Failed in updpload data"));
                }
                }
            });
        },


        //------------users selection in adobe plugin----------
        editLinkTypeFields(fieldName){
            this.editingKeyName = fieldName;
        },        
        isEditable(keyname){
            return keyname === this.editingKeyName;
        },
        getUserInfoById(userId) {
            return Utils.getDisplayDataOfUser(userId, this.getUsersBasicInfoFromStore());
        },
        updatedUsersList(option){
            if (!this.userTypes.includes(option)) {
                this.userTypes.push(option);
            }    
            // this.updateUsersListWithAdobePlugin();
        },
        removedUserFromList(option){
            this.userTypes = this.userTypes.filter(e => e != option);
            // this.selectedIds = this.selectedIds.filter(e => e != option);
        },
        updateAdobeUsersList(key){
            if(this.userTypes.length > this.adobePluginData.users_limit){
                alert(this.$t("Cannot add more than")+" " +this.adobePluginData.users_limit + " "+ this.$t("User limit exceeded"));
                return;
            }
            if(key ==   'licensed_users'){
                let payload = {};
                payload["licenseId"] = this.adobePluginData._id;
                payload["params"] = {licensed_users : this.userTypes};
                this.updateAdobePluginUsersfromServer(payload).then((response) => {
                    if (Utils.isAcceptedStatusCode(response.statusCode)) {
                        this.$toast.success(response.message ? response.message : this.$t("Updated successfully"));
                        this.editingKeyName = null;

                        // this.adobePluginData.licensed_users = [...this.userTypes];
                        let updatedAdobeData = response.updated_data || {};
                        if(this.adobePluginData._id === updatedAdobeData._id){    
                            // this.adobePluginData.licensed_users_info = [...(updatedAdobeData.licensed_users_info || [] )];
                            this.adobePluginData.licensed_users = [...(updatedAdobeData.licensed_users || [] )];
                            let licenseIdx = this.filteredLicenseInfo.findIndex(license => license._id === this.adobePluginData._id);
                            if(licenseIdx > -1){
                                this.$set(this.filteredLicenseInfo[licenseIdx], 'updated_datetime', updatedAdobeData.updated_datetime);
                            }
                        }    
                    } else {
                        if (Object.keys(response).includes("message")) {
                            this.$toast.error(response.message);
                        } else {
                            this.$toast.error(this.$t("Failed to update data"));
                        }
                    }
                });
            }
        },
        cancelAdobeUSerListUpdate(){
            this.editingKeyName = null;
            this.userTypes = [...this.adobePluginData.licensed_users];
        },
        //-----------------end of adobe plugin

        uploadSubLicenseRequest(licenseId, licenseName, event){
            let selectedFileInfo = event.target.files[0];
            if (!selectedFileInfo) return;

            let formData = new FormData();
            formData.append("files", selectedFileInfo);
            let payload = {};
            payload["licenseId"] = licenseId;
            payload["params"]=formData;
            this.getPathOfSublicenseUploadedFile(payload).then((response) => {
            
                if (Utils.isAcceptedStatusCode(response.statusCode)) {
                    if(licenseName == 'Archive storage'){
                        this.archiveStorageData = {};
                    }else if(licenseName == 'Adobe plugin'){
                        this.adobePluginData = {};
                    }
                    if (
                        Object.keys(response).includes("message") &&
                        response.message.includes("Failed")
                    ) {
                        this.$toast.warning(response.message);
                    } else {
                        if (Object.keys(response).includes("message")) {
                        this.$toast.success(response.message);
                        } else {
                        this.$toast.success(this.$t("Uploaded successfully"));
                        }
                    }
                } else {
                    if (Object.keys(response).includes("message") || Object.keys(response).includes("error")) {
                        this.$toast.error(response.error? response.error :response.message);
                    } else {
                        this.$toast.error(this.$t("Failed in updpload data"));
                    }
                }
            });
        },
        reloadLicensesList(){
            this.getLicensesListFromServer().then((response) => {
                if (Utils.isAcceptedStatusCode(response.statusCode)) {
                    if(response.license.length > 0){
                        this.licenseInfo = Array.isArray(response.license) ? response.license : [];
                    }
                }
            });
        },

        async loadPluginsDetailsPanel() {
            if (this.pluginsLicensePanelLoading) return;
            if (!this.getPluginLicensePlugins || !this.getPluginLicensePlugins.length) return;

            this.pluginsLicensePanelLoading = true;

            try {
                for (let i = 0; i < this.getPluginLicensePlugins.length; i++) {
                const plugin = this.getPluginLicensePlugins[i];

                if (!Object.prototype.hasOwnProperty.call(plugin, 'component')) {
                    let compInfo = await Utils.loadPluginBundles(
                    [plugin.pluginBundle.js],
                    plugin.componentLoadedEventName
                    );

                    if (compInfo && Array.isArray(compInfo) && compInfo.length) {
                    Utils.loadCssBundle(plugin.pluginBundle.css);

                    const ev = new Event('register-routes');
                    if (Object.prototype.hasOwnProperty.call(compInfo[0], 'pluginStore')) {
                        ev.pluginStore = compInfo[0].pluginStore;
                    }
                    parent.document.body.dispatchEvent(ev);

                    this.updatePluginsLicensePlugins({
                        id: plugin.id,
                        data: {
                        component: 'renderComponent' in plugin
                            ? compInfo[0].components[plugin.renderComponent]
                            : compInfo[0].components
                        }
                    });
                    }
                }
                }
            } finally {
                this.pluginsLicensePanelLoading = false;
            }
        },
        ...mapActions("settings", ["getLicensesListFromServer","getLicensedSystemInfoDetailsFromServer","uploadLicenseInfoToServer",
                                    "getPathOfUploadedFile", "getPathOfSublicenseUploadedFile", "getAdobePluginLicenseDatafromServer", "getArchiveStorageLicenseDatafromServer", "updateAdobePluginUsersfromServer"]),
        ...mapMutations("registry", ["updatePluginsLicensePlugins"]),
        ...mapGetters('users', ["getUsersBasicInfoFromStore"]),
    },
    computed:{
        ...mapGetters("registry",["getPluginLicensePlugins"]),
        filteredLicenseInfo(){
            return this.licenseInfo.filter(license => !this.getExternalPluginsLicenseNames.includes(license.license_name));
        },

        getExternalPluginsLicenseNames(){
            return this.getPluginLicensePlugins.map(plugin => plugin.name);
        },

        allUserInfo(){
            const usersList = (this.adobePluginData.licensed_users || []).map(user => {
                return this.getUserInfoById(user);
            });
            return usersList;
        }
    },
    created(){
        this.reloadLicensesList();
        this.loadPluginsDetailsPanel();
    }
}

</script>


<style lang="scss" scoped>
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $board-bg-color:#1a1e21;
    $board-rows-bg-color: #202729;
    $board-rows-border-color: #384445;
    $header-background: #1a1a1a;
    $background: #141414 !important;
    $body-bg-color: #0d0d0d;
    $dull-text-color: #757575;
    $options-text-color: #9c9c9c;
    $text-color: #eee;
    $table-row-border: none;
    $active-blue: #007bff;
    $modal-border: 1px solid #202020;
    $modal-background: #121212;
    $header-color: #9e9e9e;

.primary-btn-style{
    text-align: end;
    button{
        height: 38px;
        width: 172px;
        font-size:14px;
    }
    .text-light:hover{
      text-decoration: underline;
    }
}

.comm-rows-styles{
    border: 1px solid $board-rows-border-color;
    min-height: 100px;
    border-radius: 10px;
    background: $board-rows-bg-color !important;
    margin:10px 5px;
    padding:5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position:relative;
}
.parent1-ul{
    //list-style-type: none;
    padding: 0px;
    li{
        // display:inline-block;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:15%;
            text-align: end;
            text-transform:capitalize;
            float: inline-start;
            display: inline-block;
        }
        .value-style{
            color: $text-color;
            width: 70%;
            text-align: start;
            margin-inline-start: 11px;
        }
    }
    .apitalize-value{
            text-transform:capitalize;
    }
    .manage-users-style{
        width: 158px !important;
        color:$active-blue !important;
        text-align: end;
        padding-inline-end: 55px;
        svg{
            margin-inline-end: 2px;
            margin-bottom: 3px;
            fill:$active-blue !important;
        }
    }
    .manage-users-style:hover{
        text-decoration: underline;
        color:$active-blue !important;
        svg{
            fill:$active-blue !important;
        }
    }
    .child1-ul{
        //list-style-type: none;
        padding: 0px;
        margin-inline-start:10px;
        li{
            // display:inline-block;
            width: 100%;
            padding:7px;
            .key-style{
                color:$dull-text-color;
                width:22%;
                text-align: end;
                text-transform:capitalize;
                float: inline-start;
                display: inline-block;
            }
            .value-style{
                color: $text-color;
                width: 70%;
                text-align: start;
                margin-inline-start: 11px;
                text-transform:capitalize;
            }
        }
    }
    .un-ordered-lists-style{
        list-style-type: none;
    }
}

.info-component-wrapper{
    height:92%;
    overflow:auto;
}

.no-data-found{
    font-size: 20px; 
    margin-top: 8%; 
    color: $dull-text-color;
    text-align:center
}

.text-as-list-styles{
    display:inline-flex;
}

.input-fields,.mx-datepicker, textarea{
    border-radius: 3px !important;
    border: $border-color !important;
    height: 38px;
    background: $primary-background;
}

input[type="file"] {
  display: none;
}
.text-with-bullets-wrapper {
  display: inline-flex;
  margin-bottom: 10px;
}
.note-div {
  width: 99%;
  height: auto;
  display: inline-flex;
  padding: 12px;
  text-align: start;
  border: 1px solid #23485f;
  background: #10202a;
  border-radius: 5px;
  margin: 0 0 20px 0;
  color: #8aa1ad;
}

.users-basic-info-table {
  font-size: 15px;
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: #a2a2a2;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
    }
  }
}

table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: $table-row-border !important;
      border-bottom: $table-row-border !important;
    }
  }
  tbody {
    color: $text-color;
    tr {
      height: 140px;
      border-bottom: 1px solid #202020;
      td {
        border-top: $table-row-border !important;
      }
    }
  }
}

.bullets{
    height: 23px;
    width: 23px;
    border-radius: 8px;
    background: #295318;
    margin: 0 auto;
    padding-inline-start: 7px;
    padding-top: 1px;
    margin: 3px 14px 0 5px;
}
.learn-about-text-styles{
  width: 226px !important;
  color:$learn-about-text-color;
  text-align: end;
//   padding-inline-end: 17px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
    fill:$learn-about-text-color !important;
  }
}

.learn-about-text-styles:hover{
  text-decoration: underline;
  color:$learn-about-text-color-hover;
  svg{
    fill:$learn-about-text-color-hover !important;
  }
}

.tag-style{
    font-size:12px!important;
    // height: 30px!important;
    display: inline-flex!important;
    margin: 2px!important;
    // border: 1px solid $tags-border-color!important;
    // border-radius: 10px!important;
    min-width: 50px!important;
    // padding: 0!important;
    text-align: center;
    width: auto!important;
    padding-inline-start: 1px!important;
    justify-content: center;
    // padding-top: 4px!important;
    // background: $tags-background-color;
    span {
        padding: 0px 8px !important;
        margin-inline-start: 0px !important;
        font-size:12px !important;
        border-radius: 15px !important;
        position: relative !important;
        top: 1px !important;
    }
}

// Accordion
.accordion {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.acc-card {
  border: 1px solid var(--f-border);
  border-radius: 16px;
  background: #1f262a;
  overflow: hidden;
  border:1px solid #ffffff24!important;
  position: relative;
  margin-top:20px !important;
  margin:0px 30px;

  &.open {
    border-color: rgba(30, 144, 255, 0.35);

    .acc-head{
        border-bottom: 1px solid #ffffff24!important;
    }
  }
}

// .acc-card:hover{
//   .actions-on-license{
//     visibility: visible !important;
//   }
// }

.acc-head {
  padding: 8px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  cursor: pointer;
//   border-bottom: 1px solid #ffffff24!important;
  // margin-bottom: 14px;
}

.acc-left,
.acc-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.acc-right {
  justify-content: flex-end;
}

.acc-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: rgba(30, 144, 255, 0.12);
  border: 1px solid rgba(30, 144, 255, 0.28);
}

.acc-title {
  font-size: 15px;
  font-weight: 900;
  text-align: start;
}

.acc-sub {
  font-size: 12px;
  color: $dull-text-color;
}

.icon-mini {
  width: 34px;
  height: 34px;
  padding: 0;

  &.danger {
    border-color: rgba(255, 93, 93, 0.45);
  }
}

.chev {
  font-size: 18px;
  display:inline-flex;
  svg{
    color: #959595;
  }
}

.chev{
  svg:hover{
    color: #fff !important;
  }
}

.acc-body {
  padding: 0 14px 14px;
}

// Key-value grid
.kv-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(220px, 1fr));
  gap: 2px 12px;
}

.kv {
  padding: 8px 12px;
  // border-radius: 14px;
  // border: 1px solid rgba(255, 255, 255, 0.06);
  // background: rgba(255, 255, 255, 0.02);
}

.k {
  font-size: 11px;
//   text-transform: uppercase;
  letter-spacing: .06em;
  color: $dull-text-color;
  margin-bottom: 8px;
  font-weight: 800;
  text-align: start;
  padding-inline-start:4px;
}

.v {
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid #ffffff24!important;
  background: #00000029;
  color: #fff;
  font-size: 13px;
  line-height: 1.35;
  min-height: 42px;
  display: flex;
  align-items: center;
  word-break: break-word;
}

.empty {
  padding: 30px;
  text-align: center;
  color: $dull-text-color;
}

.accordion-toolbar{
  display:inline-flex;
  align-items: center;
  button{
    color: $dull-text-color;

  }
}

.accordion-toolbar:hover{
  button{
    color:#eee !important;
    text-decoration: underline;
  }
}

.actions-on-license{
    // position: absolute;
    // inset-inline-end :32px;
    border: $secondary-border-color;
    width: auto;
    height: 38px;
    border-radius: 4px;
    // top: 16px;
    padding: 2px 4px;
    background: $bg-color-on-hover;
    svg{
        margin:2px;
        background: #d1d2d31a;
        padding: 6px;
        height: 28px;
        width: 28px;
        border-radius: 4px;
        margin-inline-end: 5px;
        color: #c0c0c0;
    }
    svg:hover{
        background: #fdfeff54;
    }
}

.text-danger{
    font-weight: bold;
    color: #fb5b5b !important;
    border-color: red !important;
    background: #db3d3d1f !important;
}
// .actions-on-license{
//     visibility: hidden;
// }

    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }

    .adobe-users-wrapper{
        width:100%;
        display: inline-flex;
        padding: 0px 12px;
    }
    // .adobe-users-wrapper:hover{
    //     .editIcon{
    //         visibility: visible;
    //         margin-inline-start: 8px;
    //     }
    // }

    .editIcon{
    //     visibility: hidden;
        margin-inline-start: 8px;
    }

    .disable-users-selection{
        pointer-events:none; 
        opacity:0.6
    }

    ::v-deep{
        .disable-users-selection{
            .remove-tag{
                display: none;
            }
        }    

    .adobe-users-wrapper{
        .multiselect{
            max-width: 100%;
            width: auto;
            display: inline-block;
            float: inline-start;
        }
        .multiselect__tags{
            display: inline-block;
            border-radius: 12px;
        }
    }
    .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
            color:#5d5d5d !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: $border-color !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
        }
    }

    .acc-card,
    .acc-body,
    .adobe-users-wrapper {
        overflow: visible !important;
    }

    .adobe-users-wrapper,
    ::v-deep .multiselect {
        position: relative;
    }

    ::v-deep .multiselect__content-wrapper {
        z-index: 9999 !important;
    }

    .users-readonly-list-wrapper{
        text-align: start;
        max-width: 95%;
        width:auto;
    //     border: 1px solid #3a3f42;
    //     padding:  6px 10px;
    //     border-radius: 12px;
    //     background: #1a1f23;
    }
        .users-readonly-list{
            display: inline-flex;
            align-items: center;
            margin-inline-end: 12px;
            margin-bottom: 4px;
            border: 1px solid #3a3f42;
            padding: 0px 8px 0px 0px;
            border-radius: 10px;
            background: #1a1f23;
            height: 30px;
        }

    .user-name-or-image{
        height: 28px;
        width: 28px;
        min-width: 28px;
        border: 1px solid #4a4a4a;
        border-radius: 6px;
        text-align: center;
        text-transform: uppercase;
        font-size: 12px;
        margin-inline-end:5px;
        top:0px;
    }    

    .user-name{
        position: relative;
    }
</style>

